// extracted by mini-css-extract-plugin
module.exports = {"report":"reports_report__1BS1W","title":"reports_title__32ydf","review":"reports_review__9NlPd"};